import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesPackageDetailMain } from './modules/ui/Main';

const PackageDetailPage = (
  <SuspensePage>
    <PagesPackageDetailMain />
  </SuspensePage>
);

export default PackageDetailPage;
